"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  mounted: function mounted() {
    var _this = this;
    // console.log('1111111111111111111111111')
    // console.log( this.$refs.htmlContainer)
    fetch('./bill.html').then(function (response) {
      console.log(response);
      // if (!response.ok) throw new Error('Network response was not ok');
      // return response.text();
    }).then(function (html) {
      _this.$refs.htmlContainer.innerHTML = html;
    }).catch(function (error) {
      console.error('Failed to load HTML:', error);
    });
  }
};